// src/api/teams.js
import { apiCall } from "./client";

export const getTeams = () => apiCall("/api/teams");
export const getTeam = (teamId) => apiCall(`/api/teams/${teamId}`);
export const getTeamRiders = (teamId, { season, active, includeGuests, officialMatchId } = {}) => {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  if (active != null) params.set("active", String(active));
  if (includeGuests != null) params.set("include_guests", String(includeGuests));
  if (officialMatchId != null && officialMatchId !== "") {
    params.set("official_match_id", String(officialMatchId));
  }
  const qs = params.toString();
  return apiCall(`/api/teams/${teamId}/riders${qs ? `?${qs}` : ""}`);
};
